<template>
  <div id="gc_idx" class="relativeItem">
    <!--关闭页面的按钮-->
    <a class="close_img imgBlock" v-show="!video_show" @click="close_web">
      <img
        src="../../assets/person (1).png"
        class="absoluteItem centerImg imgBlock noevents-img"
      />
    </a>

    <img class="imgBlock noevents-img" src="../../assets/guochao/topimg.png" />
    <img
      class="imgBlock noevents-img"
      src="../../assets/guochao/topimg01.png"
    />

    <!-- 规则的点击按钮 -->
    <!-- <div class="r_btns" v-show="!video_show">
      <img
        class="imgBlock noevents-img"
        src="../../assets/guochao/roluebg.png"
      />
      <p class="absoluteItem">{{ btnText }}></p>
    </div> -->

    <!-- 报名模块 -->
    <div
      class="main_wei relativeItem"
      v-show="isStart == 0 && showFaVideo == 0 && signStatus == -1"
    >
      <img class="imgBlock noevents-img" src="../../assets/guochao/img00.png" />
      <div class="ctr_box">
        <img
          class="zhu_img absoluteItem imgBlock noevents-img"
          src="../../assets/guochao/zhu.png"
        />
        <img
          class="tit01img imgBlock noevents-img"
          src="../../assets/guochao/tit01.png"
        />
        <div class="log_main flex-box" v-show="showLog" @click="out_login">
          <p>欢迎您，</p>
          <p>请【登录】</p>
        </div>
        <div class="info_mine flex-box" v-show="!showLog">
          <div class="avt_me">
            <img
              class="imgBlock noevents-img"
              :src="sportInfo.avatar"
              onerror="this.src = 'http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
            />
          </div>
          <div class="num_main">
            <p>{{ sportInfo.nickname }}</p>
            <p>朱贝号 {{ sportInfo.user_number }}</p>
          </div>
        </div>
        <!-- 手机号 -->
        <div class="ipt_dott phone_con">
          <img
            class="imgBlock noevents-img"
            src="../../assets/guochao/xuline01.png"
          />
          <div class="ipt_con flex-box ipt_marbot">
            <input
              type="tel"
              maxlength="11"
              placeholder="请输入手机号码"
              v-model="uPhoneNum"
              v-if="bind_phone == ''"
            />
            <div v-else class="p_bind flex-box">
              <p>绑定手机号码：</p>
              <p>{{ bind_phone }}</p>
            </div>
          </div>
          <img
            class="imgBlock noevents-img"
            src="../../assets/guochao/xuline03.png"
          />
        </div>
        <!-- 验证码 -->
        <div class="yzm flex-box" v-if="bind_phone == ''">
          <div class="ym_area">
            <img
              class="imgBlock noevents-img"
              src="../../assets/guochao/xuline01.png"
            />
            <div class="ipt_con flex-box">
              <input type="number" maxlength="6" v-model="uYpass" />
            </div>
            <img
              class="imgBlock noevents-img"
              src="../../assets/guochao/xuline03.png"
            />
          </div>
          <div class="yzm_box">
            <div class="ym_btn">
              <div
                class="btn_div flex-box"
                :class="{ disable: !getCode }"
                @click="gcode"
              >
                {{ codeText }}
              </div>
            </div>
          </div>
        </div>

        <!-- 上传封面 -->
        <div class="ipt_dott phone_con">
          <img
            class="imgBlock noevents-img"
            src="../../assets/guochao/xuline01.png"
          />
          <div class="fm_box ipt_con flex-box relativeItem">
            <div
              class="absoluteItem look_imgdiv flex-box"
              v-if="coverImg != ''"
              @click="showBigCover"
            >
              <img
                class="imgBlock noevents-img"
                src="../../assets/guochao/eyes.png"
              />
              <p>查看</p>
            </div>
            <div
              :class="[
                'up_img',
                'flex-box',
                'relativeItem',
                { bdr: coverImg != '' },
              ]"
              @click="uploadCoverFun('zs_card')"
            >
              <img
                class="imgBlock noevents-img"
                src="../../assets/guochao/upimg.png"
                v-show="coverImg == ''"
              />
              <img
                v-show="coverImg != ''"
                class="imgBlock noevents-img cover_img"
                :src="coverImg"
              />
              <p class="absoluteItem edit_img" v-show="coverImg != ''">
                更换照片
              </p>
            </div>
            <div class="tip_div relativeItem">
              <p>*上传封面*</p>
              <p>请上传尺寸大于256*244px的照片</p>
            </div>
          </div>
          <img
            class="imgBlock noevents-img"
            src="../../assets/guochao/xuline03.png"
          />
        </div>
        <!-- 上传视频 -->
        <div class="ipt_dott phone_con">
          <img
            class="imgBlock noevents-img"
            src="../../assets/guochao/xuline01.png"
          />
          <div class="fm_box ipt_con flex-box relativeItem">
            <div
              :class="[
                'up_vbox',
                'relativeItem',
                { radio_con: videoSrc != '' },
              ]"
              @click="clickUpVideo"
            >
              <video
                id="video-item"
                class="video_box"
                :src="videoSrc"
                v-show="videoSrc != ''"
              ></video>
              <img
                v-show="videoSrc == ''"
                class="imgBlock noevents-img"
                src="../../assets/guochao/upvideo.png"
              />
              <p class="absoluteItem edit_vdo" v-show="videoSrc != ''">
                更换视频
              </p>
            </div>
            <div class="tip_div">
              <p>*上传视频*</p>
              <p>视频时长不超过{{ video_time }}秒</p>
              <div
                class="absoluteItem look_imgdiv02 flex-box"
                v-if="videoSrc != ''"
                @click="showVideoPlay"
              >
                <img
                  class="imgBlock noevents-img"
                  src="../../assets/guochao/icon08.png"
                />
                <p>播放</p>
              </div>
            </div>
          </div>
          <img
            class="imgBlock noevents-img"
            src="../../assets/guochao/xuline03.png"
          />
        </div>
        <div
          class="yichuan_box flex-box"
          v-show="showPublish"
          @click="videoShowFun"
        >
          <img
            class="imgBlock noevents-img"
            src="../../assets/guochao/iconup.png"
          />
          <p>选择已发布视频</p>
        </div>
        <!-- 按钮 -->
        <div class="btn_con" v-show="!allowClick">
          <img
            class="imgBlock noevents-img"
            src="../../assets/guochao/huibtn.png"
          />
        </div>
        <div class="btn_con" v-show="allowClick" @click="signInFun">
          <img
            class="imgBlock noevents-img"
            src="../../assets/guochao/btncan.png"
          />
        </div>
      </div>
      <img class="imgBlock noevents-img" src="../../assets/guochao/img02.png" />
    </div>

    <!-- 选择呢已发布的视频 -->
    <div class="fa_mian relativeItem" v-if="isStart == 0 && showFaVideo == 1">
      <img
        class="bgk imgBlock noevents-img"
        src="../../assets/guochao/bgk.png"
      />
      <div class="fa_top absoluteItem centerX">
        <img
          class="imgBlock noevents-img"
          src="../../assets/guochao/yifap.png"
        />
      </div>
      <div class="scrol_div absoluteItem centerX">
        <ul class="flex-box">
          <li
            class="lis relativeItem"
            :style="{ height: ziWidth + 'px' }"
            v-for="(n, i) in allVideoList"
            :key="i"
          >
            <video
              controls
              autoplay="false"
              controlslist="nodownload"
              style="object-fit: fill"
              playsinline="true"
              webkit-playsinline="true"
              x-webkit-airplay="allow"
              airplay="allow"
              x5-video-player-type="h5"
              x5-video-player-fullscreen="true"
              x5-video-orientation="portrait"
              class="my_vbox"
              :id="'vdo_' + i"
              :src="n.video_address"
            ></video>

            <div
              :class="[
                'absoluteItem',
                'select_box',
                { ac_sel_video: ac_video == i },
              ]"
              @click="ac_video = i"
            ></div>
          </li>
        </ul>
      </div>
      <p class="line absoluteItem centerX"></p>

      <div class="bot_btns absoluteItem centerX flex-box">
        <div @click="videoSeleFun">
          <img
            class="imgBlock noevents-img"
            src="../../assets/guochao/confirm.png"
          />
        </div>
        <div @click="showFaVideo = 0">
          <img
            class="imgBlock noevents-img"
            src="../../assets/guochao/fanhui.png"
          />
        </div>
      </div>
    </div>

    <!-- 报名后 审核的板块 -->
    <div class="shen_main relativeItem" v-if="isStart == 0 && signStatus == 0">
      <img
        class="bgk imgBlock noevents-img"
        src="../../assets/guochao/bgk.png"
      />
      <div class="shen_text absoluteItem centerImg">
        <p>已成功提交报名资料</p>
        <p>审核中...</p>
      </div>
    </div>

    <!-- 审核未通过 -->
    <div class="shen_main relativeItem" v-if="isStart == 0 && signStatus == 2">
      <img
        class="bgk imgBlock noevents-img"
        src="../../assets/guochao/bgk.png"
      />
      <div class="ctr_text absoluteItem centerImg flex-box">
        <p>报名资料未通过</p>
        <p class="err_reson flex-box">
          原因：
          {{ errorReson }}
        </p>
        <div class="re_submit" @click="reSubmitFun">
          <img
            class="imgBlock noevents-img"
            src="../../assets/guochao/reSubmit.png"
          />
        </div>
      </div>
    </div>

    <!-- 成功敬请期待 -->
    <div class="shen_main relativeItem" v-if="isStart == 0 && signStatus == 1">
      <img
        class="bgk imgBlock noevents-img"
        src="../../assets/guochao/qidai.png"
      />
      <div class="qidai_text absoluteItem centerX">
        <p>报名成功，活动于{{ sportInfo.start_date }}开始</p>
        <!-- <p class="qd_p2"> <span></span> 敬请期待 <span></span></p> -->
        <p class="qd_p2">敬请期待</p>
      </div>
    </div>

    <!-- 活动结束后的列表页面组件 -->
    <div class="over_main relativeItem" v-if="isStart == 1">
      <overCom @changeBtn="changeBtn($event)"></overCom>
    </div>

    <!-- 底部的文字 -->
    <div class="bot_text">
      <img
        class="imgBlock noevents-img"
        src="../../assets/guochao/bottext.png"
      />
    </div>

    <!--图片裁剪工具-->
    <cropper-image2
      v-show="cropperModel"
      :img_item_id="img_item_id"
      :fixedNumber="fixedNumber"
      @uploadImgSuccess="handleUploadSuccess"
      @close_cropper="cropperModel = false"
      ref="child"
    >
    </cropper-image2>

    <!--视频上传工具-->
    <upVideo
      v-show="up_video"
      :img_item_id="img_item_id"
      :title="'请选择上传视频'"
      :sub="'支持单个视频最长15秒'"
      :time="video_time"
      @uploadVideoSuccess="up_video_fun"
      @close_upvideo="up_video = false"
      ref="child"
    ></upVideo>

    <!-- 图片的预览 -->
    <div class="cover_tc tc_img" @click="coverShow = false" v-show="coverShow">
      <img class="absoluteItem centerImg" :src="coverImg" @click.stop />
    </div>

    <!-- 视频的预览 -->
    <div class="cover_vdo tc_img" @click="videoShow = false" v-if="videoShow">
      <video
        @click.stop
        id="video_yu"
        class="video_box"
        controls
        controlslist="nodownload"
        style="object-fit: fill"
        playsinline="true"
        webkit-playsinline="true"
        x-webkit-airplay="allow"
        airplay="allow"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        x5-video-orientation="portrait"
        :src="videoSrc"
        :poster="coverImg"
      ></video>
      <div class="colse_btn flex-box" @click="videoShow = false">×</div>
    </div>
  </div>
</template>

<script>
import overCom from "./overCom";
import CropperImage2 from "../index/CropperImage";
import upVideo from "../index/up_video";
let Base64 = require("js-base64").Base64;

export default {
  name: "gc_idx",
  components: {
    overCom,
    CropperImage2,
    upVideo,
  },
  data() {
    return {
      fixedNumber: [1, 1.7], //裁剪工具的缩放比例
      coverShow: false, //封面的预览
      videoShow: false, //视频的预览
      video_show: false,
      btnText: "活动规则", //按钮文字的切换
      allowClick: false, //用户提交报名的按钮状态显示
      ziWidth: 66, //视频的高度
      ac_video: 0, //默认选择的发布视频
      allVideoList: [],
      showFaVideo: 0, //各个模块的显示 0 报名  1选择已发布的视频
      isStart: 0, //状态表示  0未开始  1开始
      signStatus: -1, //-1未报名  0审核中   1审核成功    2审核失败
      errorReson: "照片与实际不符合",
      page: 1, //我的视频列表的页数
      showPublish: false, //显示已发布的视频字段
      cropperModel: false, ////裁切图片参数
      img_item_id: "", //预览的img标签对象 一般是id
      coverImg: "", //封面的链接
      coverFile: null, // 图片的file格式
      cre_type: 0, //0 上传 1更换
      videoSrc: "", //视频的路径
      videoFile: null, //用于上传的视频文件
      video_time: "15", //视频的时长
      up_video: false, //上传视频的显示
      acMyVdoId: 0, //我的动态视频默认选中的索引
      sportInfo: {}, //活动的有关信息  包含自己的信息
      showLog: false,
      uPhoneNum: "", //手机号
      uYpass: "", //验证码
      codeText: "获取验证码",
      getCode: false, //是否可以
      bind_phone: "", //后台返回的用户绑定的手机号  为空就说明未绑定  显示输入手机号验证码   有的话  直接隐藏手机号验证码
    };
  },
  mounted() {
    this.$tool.setTitle("华风少年");
    this.judgeLogin();
  },
  methods: {
    /**关闭webview */
    close_web() {
      this.$appAc.closeWeb();
    },

    // 判断是否登录
    judgeLogin() {
      if (this.$cookie.getC("platform") == "app") {
        //app内部
        if (!this.$tool.isStr(this.$cookie.getC("userid"))) {
          //app内部也没有登录 调用app的登录方式
          this.showLog = true;
          return false;
        } else {
          this.showLog = false;
        }
      } else {
        //外部浏览器
        if (!this.$tool.isStr(this.$cookie.getC("token"))) {
          this.showLog = true;
          this.$tool.login_comfirm();
          return false;
        } else {
          this.showLog = false;
        }
      }
      this.judgeSignStatus(); //获取报名状态
    },

    /**在外部浏览器使用的登录
     * 点击“请登录”触发
     */
    out_login() {
      if (this.$cookie.getC("platform") != "app") {
        this.$tool.login_comfirm();
      }
    },

    changeBtn(val) {
      this.video_show = val;
    },
    // 计算视频盒子的高度
    caluScrollZiHeight() {
      setTimeout(() => {
        this.ziWidth = document.querySelector(".lis").offsetWidth;
      }, 300);
    },

    // 选择已发布的视频点击后
    videoShowFun() {
      this.showFaVideo = 1;
      this.caluScrollZiHeight();
    },

    // 确定选择视频的方法
    videoSeleFun() {
      this.acMyVdoId = this.allVideoList[this.ac_video].liveid;
      this.showFaVideo = 0;
      // 给视频赋值
      this.videoSrc = this.allVideoList[this.ac_video].video_address;
    },

    // 重新提交的点击
    reSubmitFun() {
      this.signStatus = -1;
    },

    // 获取报名状态
    judgeSignStatus() {
      let _this = this;
      this.$jsonp(this.$apis("gc_vertify_signstatus"), {}, (res) => {
        if (res.data.data.status == 1) {
          _this.isStart = res.data.data.data.act_status;
          _this.signStatus = res.data.data.data.status;
          _this.errorReson = res.data.data.data.reason;
          _this.sportInfo = res.data.data.data;
          _this.bind_phone = res.data.data.data.mobile;
        } else {
          if (res.data.data.msg == "还未登录") {
            //显示登录按钮
            _this.showLog = true;
          }
          _this.$tool.tip(res.data.data.msg, "50%");
        }
        if (_this.isStart == 0) {
          _this.getMineVlist(); //获取我的视频列表
        }
      });
    },

    // 预览图片
    showBigCover() {
      this.coverShow = true;
    },

    // 视频的预览
    showVideoPlay() {
      this.videoShow = true;
      document.getElementById("video_yu").play();
    },

    // 获取我的视频列表
    getMineVlist() {
      let _this = this;
      let data = {
        page: _this.page,
        pageSize: 30,
      };
      this.$jsonp(this.$apis("gc_mine_videolist"), data, (res) => {
        if (res.data.data.data.length != 0) {
          _this.showPublish = true;
          _this.allVideoList = res.data.data.data;
        } else {
          _this.showPublish = false; //没有视频就隐藏选择已发布视频的字段
        }
      });
    },

    // 国潮的报名接口
    async signInFun() {
      if (this.coverFile == null) {
        this.$tool.tip("请选择封面图片~", "50%");
        return;
      }
      if (this.videoSrc == "") {
        this.$tool.tip("请上传视频~", "50%");
        return;
      }
      let _this = this;

      let data = {
        cover_image: _this.coverFile,
      };

      if (this.bind_phone == "") {
        data.mobile = _this.uPhoneNum;
        data.code = _this.uYpass;
      }

      if (this.acMyVdoId * 1 != 0) {
        data.liveid = _this.acMyVdoId; //自己的视频列表选择的视频id
      } else {
        data.video = _this.videoFile; //手动上传的视频对象
      }
      let formData = new FormData();
      formData.append("cover_image", data.cover_image);
      if (this.bind_phone == "") {
        formData.append("mobile", data.mobile);
        formData.append("code", data.code);
      }
      if (this.acMyVdoId * 1 != 0) {
        formData.append("liveid", data.liveid);
      } else {
        formData.append("video", data.video);
      }

      if (this.$cookie.getC("platform") == "app") {
        let token = Base64.encode(this.$cookie.getC("userid"));
        formData.append("token", token);
      } else {
        formData.append("token", this.$cookie.getC("token"));
      }
      _this.$tool.showLoading();

      await this.$http
        .post(this.$apis("gc_signin"), formData)
        .then(function (res) {
          _this.$tool.hiddenLoading();
          if (res.data.data.status == 1) {
            _this.$tool.tipImg(res.data.data.msg, "success");
            _this.signStatus = 0; //显示审核中的模块
          } else {
            _this.$tool.tipImg(res.data.data.msg, "error");
          }
        });
    },

    // 上传封面
    uploadCoverFun(id) {
      this.img_item_id = id;
      this.cropperModel = true;
    },

    // 图片上传成功
    handleUploadSuccess(data) {
      let _this = this;
      let fr = new FileReader();
      fr.readAsDataURL(data.obj);
      fr.onload = function (res) {
        if (_this.cre_type == 0) {
          _this.cre_type = 1;
        }
        _this.coverImg = res.target.result;
      };
      _this.coverFile = new window.File([data.obj], "cover_image", {
        type: data.obj.type,
      });
    },

    //显示视频上传的组件
    clickUpVideo() {
      this.up_video = true;
    },

    // 视频的回调
    up_video_fun(data) {
      this.videoSrc = data.url;
      //先暂停视频播放
      // document.getElementById("video_yu").pause();
      //用于上传的视频资源
      this.videoFile = data.video;
    },

    //获取验证码
    gcode() {
      //判断手机号码是否完整
      if (!this.$tool.checkPhone(this.uPhoneNum)) {
        this.$tool.tip("请填写正确的手机号码", "50%");
        return;
      }
      //判断是否能发送验证码
      if (this.getCode) {
        this.getCode = false;
      } else {
        return;
      }

      let _this = this;
      let data = {
        mobile: _this.uPhoneNum,
      };
      this.$jsonp(this.$apis("ty_msg"), data, (res) => {
        if (res.data.data.status == 200) {
          _this.$tool.tip("验证码已发送");
          //发送成功
          _this.getCode = false;
          let num = 59;
          let co = setInterval(() => {
            num--;
            _this.codeText = "再次获取(" + num + ")";
            if (num == 0) {
              clearInterval(co);
              _this.codeText = "获取验证码";
              _this.getCode = true;
            }
          }, 1000);
        } else {
          _this.getCode = true;
          _this.$tool.tip(res.data.data.msg);
        }
      });
    },
  },
  watch: {
    videoSrc() {
      if (this.videoSrc == "") {
        this.allowClick = false;
      } else {
        this.allowClick = true;
      }
    },
    videoShow(val) {
      if (!val) {
        //暂停视频播放
        document.getElementById("video_yu").pause();
      }
    },
  },
};
</script>

<style scoped>
#gc_idx {
  width: 100%;
  overflow-x: hidden;
  min-height: 100vh;
  background-color: #ebf6fd;
}
.close_img {
  position: fixed;
  width: 42px;
  height: 30px;
  background-color: rgba(0, 0, 0, 0.4);
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  top: 8%;
  z-index: 18;
}
.close_img img {
  width: 20px;
  height: 20px;
}

.r_btns {
  position: fixed;
  top: 50%;
  right: -8px;
  z-index: 3;
}
.r_btns img {
  width: 80px;
  height: 30px;
}
.r_btns p {
  width: 100%;
  font-size: 13px;
  font-weight: bold;
  color: #09502a;
  top: 40%;
  left: 60%;
  transform: translate(-50%, -50%);
}
.ctr_box {
  min-height: 305px;
  background: url("../../assets/guochao/img01.png") repeat;
  background-size: 100% 100%;
}
.ctr_box .zhu_img {
  left: 4%;
  top: 8%;
  width: 80px;
  min-height: 460px;
  max-height: 500px;
}

.main_wei {
  margin: -20% 0 -34%;
  z-index: 2;
  overflow: hidden;
}
.tit01img {
  width: 63%;
  margin: 6px auto;
  margin-top: -1%;
}
.bot_text {
  width: 100%;
}
.ipt_dott {
  width: 72%;
  margin-left: 15%;
}
.log_main {
  width: 100%;
  justify-content: center;
  padding: 12px 0;
  color: #0c526f;
  font-size: 0.75rem;
}
.log_main p:nth-child(2) {
  font-weight: bold;
}
.info_mine {
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
}
.avt_me {
  width: 3.4375rem;
  height: 3.4375rem;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #fff;
  margin-right: 8px;
}
.num_main p:nth-child(1) {
  color: #0c526f;
  font-size: 0.75rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.num_main p:nth-child(2) {
  font-size: 0.6875rem;
  color: #778994;
}
.ipt_marbot {
  margin-bottom: -2px;
}
.ipt_con {
  padding: 0 2px;
  background: url("../../assets/guochao/xuline02.png") repeat;
  background-size: 100% 100%;
}
.ipt_con input {
  width: 100%;
  height: 35px;
  padding-left: 15px;
  font-size: 0.8125rem;
  color: #3f8eaf;
}
.ipt_con input::-webkit-input-placeholder {
  font-size: 0.8125rem;
  color: #3f8eaf;
}
.ipt_con input:-moz-placeholder {
  font-size: 0.8125rem;
  color: #3f8eaf;
}
.ipt_con input::-moz-placeholder {
  font-size: 0.8125rem;
  color: #3f8eaf;
}

.phone_con {
  margin-top: 6px;
}
.ipt_con .p_bind {
  padding-left: 8px;
  width: 100%;
  height: 35px;
  /* justify-content: center; */
  align-items: center;
  font-size: 0.75rem;
  color: #3f8eaf;
}
.fm_box {
  height: 70px;
  align-items: center;
  padding: 2px 6px 2px 8px;
}
.up_img {
  width: 60px;
  height: 60px;
  align-items: center;
}
.radio_con {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #afcbca;
}
.up_vbox {
  width: 60px;
  height: 60px;
  align-items: center;
}

.up_img .cover_img {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
}
.edit_img,
.edit_vdo {
  bottom: 0;
  left: 0;
  width: 60px;
  text-align: center;
  color: #fff;
  padding: 3px 0;
  font-size: 0.5625rem;
  background-color: rgba(0, 0, 0, 0.7);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.tip_div {
  margin-left: 12px;
}
.tip_div p:nth-child(1) {
  font-weight: bold;
  font-size: 0.75rem;
  color: #3f8eaf;
  padding-bottom: 6px;
}
.tip_div p:nth-child(2) {
  font-size: 0.6875rem;
  color: #3f8eaf;
}
.look_imgdiv {
  right: 6px;
  top: 1px;
  align-items: center;
  font-size: 0.6875rem;
  padding: 5px 8px;
}
.look_imgdiv p {
  font-size: 0.75rem;
  color: #3f8eaf;
}
.look_imgdiv img {
  padding-top: 2px;
  width: 15px;
  height: 11px;
  margin-right: 3px;
}

.look_imgdiv02 {
  right: 6px;
  top: 3px;
  padding: 5px 8px;
  align-items: center;
  font-size: 0.6875rem;
}
.look_imgdiv02 img {
  width: 13px;
  height: 13px;
  margin-right: 3px;
}
.tip_div .look_imgdiv02 p {
  color: #3f8eaf;
}
.yichuan_box {
  align-items: center;
  justify-content: flex-end;
  color: #10729b;
  font-size: 0.75rem;
  padding-top: 6px;
  padding-right: 14.5%;
}
.yichuan_box img {
  width: 17px;
  height: 14px;
  margin-right: 6px;
}
.btn_con {
  width: 160px;
  height: 50px;
  margin: 20px auto 0;
}
.btn_con img {
  width: 160px;
  height: 50px;
}

/* 选择已发布视频模块 */
.fa_mian {
  width: 90%;
  height: 350px;
  margin: -18% auto -34%;
  z-index: 2;
}
.fa_mian .bgk {
  height: 350px;
}

.fa_top {
  top: 32px;
}
.fa_top img {
  width: 90%;
  margin: auto;
}
.scrol_div {
  top: 20%;
  width: 85%;
  height: 200px;
  overflow-y: scroll;
  padding-bottom: 8px;
}
.scrol_div ul {
  flex-wrap: wrap;
}
.scrol_div li {
  width: 23%;
  height: 50px;
  background-color: #fff;
  border-radius: 8px;
  margin-right: 2%;
  margin-bottom: 5px;
  box-sizing: border-box;
  border: 1px solid #309502;
  overflow: hidden;
}
.fm_img {
  width: 100%;
  height: 100%;
}

.line {
  width: 85%;
  height: 1px;
  background-color: #c0d1c8;
  bottom: 72px;
}
.bot_btns {
  bottom: 30px;
  width: 100%;
  padding: 6px 15% 0;
  justify-content: space-around;
}
.bot_btns img {
  width: 92px;
  height: 33px;
}
.play_box {
  right: 3px;
  bottom: 3px;
}
.play_box img {
  width: 18px;
  height: 17px;
}
.select_box {
  left: 3px;
  top: 3px;
  border-radius: 50%;
  width: 11px;
  height: 11px;
  background-color: rgba(0, 0, 0, 0.6);
}
.lis .ac_sel_video {
  background-color: #45dc88;
  border: 1px solid #1d2021;
}
/* 报名审核的模块 */
.shen_main {
  margin: -18% 0 -30%;
  z-index: 2;
  padding: 0 5%;
}
.shen_text {
  color: #254254;
  font-size: 1rem;
  text-align: center;
  font-weight: bold;
}

.shen_text p:nth-child(2) {
  padding-top: 8px;
  font-size: 0.9375rem;
}
/* 未通过的 */
.ctr_text {
  width: 80%;
  padding-top: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.ctr_text p:nth-child(1) {
  color: #254254;
  font-size: 1rem;
  text-align: center;
  font-weight: bold;
}
.ctr_text .err_reson {
  width: 60%;
  justify-content: flex-start;
  color: #254254;
  font-size: 0.875rem;
  padding: 5px 0;
  height: 90px;
  line-height: 1.5;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
}
.re_submit img {
  width: 96px;
  height: 35px;
  margin: 38px auto;
}
.qidai_text {
  width: 80%;
  color: #254254;
  font-size: 1rem;
  text-align: center;
  font-weight: bold;
  top: 30%;
}
.qidai_text .qd_p2 {
  position: relative;
  padding-top: 6px;
}

.qidai_text .qd_p2::before,
.qidai_text .qd_p2::after {
  position: absolute;
  content: "";
  width: 6px;
  height: 6px;
  background: #254254;
  top: 46%;
  transform: rotateZ(45deg);
}

.qidai_text .qd_p2::before {
  left: 34%;
}
.qidai_text .qd_p2::after {
  right: 35%;
}
.over_main {
  margin: -18% 0 -30%;
  z-index: 2;
}
.video_box {
  width: 60px;
  height: 60px;
}
.my_vbox {
  width: 100%;
  height: 100%;
}
.padTop {
  padding-top: 6px;
}
.cover_tc img {
  width: 100%;
}
.cover_vdo {
  width: 110vw;
  height: 100vh;
}
#video_yu {
  width: 100vw;
  height: 100vh;
  z-index: 30;
}
.colse_btn {
  position: fixed;
  bottom: 8%;
  right: 8%;
  color: #fff;
  font-size: 1rem;
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid #fff;
}
.bdr {
  border: 1px solid #7a97a6;
  border-radius: 8px;
}
.tc_img {
  position: fixed;
  z-index: 20;
  background: rgba(0, 0, 0, 0.7);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.yzm {
  width: 72%;
  margin-left: 15%;
  margin-top: 8px;
}
.yzm .ym_area {
  width: 68%;
}
.yzm_box {
  padding: 3px 0 3px 3px;
  width: 30%;
  margin-left: 2%;
  box-sizing: border-box;
}
.ym_btn {
  border: 1px solid #0daa57;
  border-radius: 6px;
  width: 100%;
  height: 100%;
  padding: 2px;
}
.btn_div {
  background-color: #0daa57;
  border-radius: 6px;
  height: 100%;
  color: #fff;
  font-size: 0.6875rem;
  justify-content: center;
  align-items: center;
}
</style>
